import React from 'react';
import './PrivacyPolicyPopup.css';

const PrivacyPolicyPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="privacy-popup-overlay" onClick={onClose}>
      <div className="privacy-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-popup-header">
          <h2>개인정보처리방침</h2>
          <button className="privacy-popup-close" onClick={onClose}>×</button>
        </div>
        
        <div className="privacy-popup-body">
          <div className="privacy-section">
            <h3>제 1조 총칙</h3>
            <p>
              태봉산업기술(주) ("회사" 또는 "태봉산업기술"이라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 등 정보통신서비스 제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 긔거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
            </p>
            <p>
              본 개인정보처리방침은 회사가 제공하는 관련 서비스 이용에 적용되며 다음과 같은 내용을 담고 있습니다.
            </p>
            <p>
              1. 개인정보란 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보를 말합니다.
            </p>
            <p>
              2. 이용자의 개인정보를 매우 중요시 하고, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등의 관련 법률을 준수하고 있으며, 그에 의거한 개인정보처리방침을 정하여 이용자의 권익 보호에 최선을 다하고 있습니다.
            </p>
            <p>
              3. 당사는 개인정보처리방침을 통하여 이용자께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </p>
            <p>
              4. 당사는 개인정보처리방침을 홈페이지 첫 화면에 공개함으로써 이용자께서 언제나 용이하게 보실 수 있도록 조치하고 있습니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 2조 수집하는 개인정보 항목 및 수집방법</h3>
            <p>
              1. 수집하는 개인정보의 항목
            </p>
            <p>
              회사는 원활한 고객상담 및 견적서비스의 제공을 위해 최초 견적 문의시 아래와 같은 개인정보를 수집하고 있습니다.
            </p>
            <p>
              - 이름, 이메일, 전화번호, 휴대폰번호, 팩스번호
            </p>
            
            <p>
              2. 개인정보 수집방법
            </p>
            <p>
              회사는 다음과 같은 방법으로 개인정보를 수집합니다.
            </p>
            <p>
              - 견적서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우, 해당 개인정보를 수집합니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 3조 개인정보의 수집 및 이용목적</h3>
            <p>
              온라인 견적서비스의 회신 및 문의사항 발생시 이용자와의 연결을 목적으로 사용합니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 4조 개인정보 취급 위탁 및 제3자 제공 안내</h3>
            <p>
              태봉산업기술은 귀하의 개인정보를 외부에 수집, 취급, 관리 등 위탁업무를 하지 않습니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 5조 개인정보의 보유 및 이용기간</h3>
            <p>
              이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 6조 개인정보의 파기절차 및 그 방법</h3>
            <p>
              이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
            </p>
            
            <p>
              1. 파기절차
            </p>
            <p>
              - 이용자가 온라인 견적요청을 위하여 입력한 정보는 목적이 달성된 후 별도의 DB(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정기간 저장된 후 파기됩니다.
            </p>
            <p>
              - 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
            </p>
            
            <p>
              2. 파기방법
            </p>
            <p>
              - 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기숙적 방법을 사용하여 삭제합니다.
            </p>
            <p>
              - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 7조 이용자 권리와 그 행사방법</h3>
            <p>
              이용자는 자신의 개인정보를 조회 할 수는 없으나(홈페이지내 회원가입 없음) 수정 및 파기를 요청 할 수 있습니다.
            </p>
            <p>
              만 14세 미만 아동의 경우, 법정대리인이 아동의 개인정보를 조회하거나 수정할 권리, 수집 및 이용 동의를 철회할 권리를 가집니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 8조 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h3>
            <p>
              태봉산업기술의 홈페이지는 이용자가 회원가입 없이 이용하실 수 있습니다. 이에 따라서 개인정보 자동 수집 장치의 설치/운영을 하지 않고 있습니다.
            </p>
          </div>

          <div className="privacy-section">
            <h3>제 9조 개인정보관리책임자 및 담당자의 연락처</h3>
            <p>
              이용자는 회사의 서비스를 이용하면서 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.
            </p>
            <p>
              - 개인정보 관리 책임자(담당부서)
            </p>
            <p>
              성명 : 이형구
            </p>
            <p>
              소속 : 설계팀
            </p>
            <p>
              직위 : 차장
            </p>
            <p>
              메일 : saledept@taibong.com
            </p>
            <p>
              전화 : 032-811-0511
            </p>
            <p>
              팩스 : 032-819-0518
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPopup;
